import { render, staticRenderFns } from "./orgTable.vue?vue&type=template&id=bc020fe8&scoped=true"
import script from "./orgTable.vue?vue&type=script&lang=ts"
export * from "./orgTable.vue?vue&type=script&lang=ts"
import style0 from "./orgTable.vue?vue&type=style&index=0&id=bc020fe8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc020fe8",
  null
  
)

export default component.exports